import { render } from "./v-navigation.vue?vue&type=template&id=e0deeb2a&scoped=true"
import script from "./v-navigation.vue?vue&type=script&lang=js"
export * from "./v-navigation.vue?vue&type=script&lang=js"

import "./v-navigation.vue?vue&type=style&index=0&id=e0deeb2a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0deeb2a"]])

export default __exports__